import { render, staticRenderFns } from "./Processes.vue?vue&type=template&id=35e1244c&scoped=true&"
import script from "./Processes.vue?vue&type=script&lang=js&"
export * from "./Processes.vue?vue&type=script&lang=js&"
import style0 from "./Processes.vue?vue&type=style&index=0&id=35e1244c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1244c",
  null
  
)

export default component.exports